import { InvitePage } from './Invite';

export function LoginPage() {
  return (
    <div className="login-page">
      <InvitePage />
    </div>
  );
}
